import React, { useState } from "react";
import { Icon } from "ui/components";
import { cx } from "utils/join-classnames";
import styles from "./PasswordField.module.scss";

type Props = {
    theme: string;
    defaultText: string;
    onValueChanged(value: string): void;
    id?: string;
    valid?: boolean;
    disabled?: boolean;
};

const PasswordField: React.FC<Props> = ({
    theme,
    defaultText,
    onValueChanged,
    id = undefined,
    valid = true,
    disabled = false,
}: Props) => {
    const [visible, setVisible] = useState<boolean>(false);
    const catchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onValueChanged(e.target.value);
    };

    return (
        <div className={styles.passwordfieldcontainer}>
            <input
                type={visible ? "text" : "password"}
                onChange={catchChange}
                className={cx(
                    styles.passwordfield,
                    theme && theme === "dark"
                        ? styles.passwordfield__dark
                        : styles.passwordfield__light,
                    !valid &&
                        valid !== undefined &&
                        styles.passwordfield__invalid,
                )}
                placeholder={defaultText}
                id={id}
                disabled={disabled}
            />
            <div onClick={() => setVisible(!visible)} aria-hidden="true">
                <Icon
                    name={visible ? "visible-off" : "visible"}
                    className={cx(
                        styles.icon,
                        theme && theme === "dark" && styles.icon__dark,
                    )}
                />
            </div>
        </div>
    );
};

export default PasswordField;
